export default __webpack_public_path__ + "41ac1f1e878f6dfa6a5eb45b26720b62.jpg";